module.exports = __webpack_public_path__ + "0b0f129b56dfa3e858e6f5ff4d11113e.pdf";